import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getEvent } from '../firebase';
import { Event } from '../types';

const EventRegistrationSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState(true);

  // Determine if we're in the portal or public route
  const isPortalRoute = location.pathname.startsWith('/portal');

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const eventId = searchParams.get('event');
        
        if (!eventId) {
          setLoading(false);
          return;
        }
        
        const eventData = await getEvent(eventId);
        setEvent(eventData);
      } catch (error) {
        console.error('Error fetching event:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchEvent();
  }, [location]);

  const handleBackToEvents = () => {
    if (isPortalRoute) {
      navigate('/portal/events');
    } else {
      navigate('/events');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-6">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold mb-4">Registration Successful!</h1>
        
        {event ? (
          <p className="text-lg mb-4">
            Thank you for registering for <span className="font-semibold">{event.title}</span>. 
            We look forward to seeing you on {event.date} at {event.time}.
          </p>
        ) : (
          <p className="text-lg mb-4">
            Thank you for registering for this event.
          </p>
        )}
        
        <p className="text-gray-600 mb-8">
          A confirmation email with your ticket information has been sent to your email address.
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button 
            onClick={handleBackToEvents}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded"
          >
            Back to Events
          </button>
          <button 
            onClick={() => window.print()}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-3 rounded"
          >
            Print Confirmation
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventRegistrationSuccess; 